// reasonCodeApi.ts

import axios from "./axiosInstance";
interface ReasonCodeRow {
  id: string;
  reasonCode: string;
  reasonDescription: string;
}
export const getReasonCodeList = async () => {
  const response = await axios.get("/api/get-codes");
  return response.data;
};

export const manageApi = async (payload: any) => {
  const response = await axios.post("/api/admin/manage", payload);
  return response.data;
};

export const getHistoryApi = async (reasonCode: string) => {
  const response = await axios.get(
    `/api/admin/history/${reasonCode}`
  );
  return response.data;
};